<template>
  <div>
    <v-dialog
      :fullscreen="$vuetify.breakpoint.name == 'xs'"
      persistent
      v-model="dialog"
      width="700"
    >
      <v-card>
        <v-toolbar dark>
          <v-toolbar-title>
            {{
              selectedIndex == -1 ? "ADD NEW OPTION" : "EDIT OPTION"
            }}</v-toolbar-title
          >
          <v-spacer></v-spacer>
          <v-btn icon @click="closeDialog()">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="body__card">
          <v-form v-model="valid" ref="form" lazy-validation>
            <v-layout wrap>
              <v-flex xs12 sm6 class="pr-2">
                <v-text-field
                  label="NAME TH"
                  v-model="form.option_name_th"
                  :rules="[(v) => !!v || 'required']"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 class="pr-2">
                <v-text-field
                  label="NAME EN"
                  v-model="form.option_name_en"
                  :rules="[(v) => !!v || 'required']"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 class="pr-2">
                <v-text-field
                  label="NAME CN"
                  v-model="form.option_name_cn"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 class="pr-2">
                <v-checkbox
                  label="Need to select ?"
                  v-model="form.option_require"
                ></v-checkbox>
              </v-flex>
              <v-flex sm6>
                <v-radio-group v-model="form.option_type" row>
                  <v-radio :value="1" label="Single"></v-radio>
                  <v-radio
                    :value="2"
                    label="Multiple"
                  ></v-radio> </v-radio-group
              ></v-flex>
              <v-flex sm6
                ><v-text-field
                  v-if="form.option_type == 2"
                  label="AMOUNT SELECT"
                  type="number"
                  :rules="[(v) => !!v || 'required']"
                  v-model="form.option_amount"
                ></v-text-field
              ></v-flex>
            </v-layout>
            <div style="display: flex; align-items: center" class="mt-2">
              <span class="body__title--choice">CHOICE LIST</span>
              <v-btn icon @click="moreChoice()"
                ><v-icon color="green">add</v-icon></v-btn
              >
            </div>
            <div
              class="body__card--choice mt-3"
              v-for="(choice, i) in form.option_choice"
              :key="i"
            >
              <v-layout wrap>
                <v-flex xs12 style="display: flex; align-items: center">
                  <span class="card__number">{{ i + 1 }}</span>
                  <v-spacer></v-spacer>
                  <v-btn icon @click="removeChoice(i)"
                    ><v-icon color="red">delete</v-icon></v-btn
                  >
                </v-flex>
                <v-flex xs12 sm6 class="pr-2">
                  <v-text-field
                    v-model="choice.choice_name_th"
                    label="CHOICE NAME TH"
                    :rules="[(v) => !!v || 'required']"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 class="pr-2">
                  <v-text-field
                    v-model="choice.choice_name_en"
                    label="CHOICE NAME EN"
                    :rules="[(v) => !!v || 'required']"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 class="pr-2">
                  <v-text-field
                    v-model="choice.choice_name_cn"
                    label="CHOICE NAME CN"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 class="pr-2">
                  <v-text-field
                    type="number"
                    v-model="choice.choice_price"
                    label="CHOICE PRICE"
                    :rules="[(v) => !!v || 'required']"
                  ></v-text-field> </v-flex
              ></v-layout>
            </div>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="error"
            @click="resetForm()"
            v-if="this.selectedIndex == -1"
            >reset</v-btn
          >
          <v-btn color="success" @click="submit()">save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: ["dialog", "selectedIndex", "form"],
  data() {
    return {
      valid: true,
    };
  },
  watch: {
    dialog() {
      this.$refs.form.resetValidation();
    },
  },
  methods: {
    closeDialog() {
      this.$emit("close");
    },
    validateStart(value, index) {
      if (index == 0) {
        return true;
      } else {
        return (
          value >
          parseFloat(this.form.distance_text[index - 1].transport_charge_end)
        );
      }
    },
    validateEnd(value, index) {
      return (
        value >
        parseFloat(this.form.distance_text[index].transport_charge_start)
      );
    },
    removeCondition(index) {
      if (this.form.distance_text.length > 1) {
        this.form.distance_text.splice(index, 1);
      }
    },
    moreChoice() {
      this.form.option_choice.push({
        choice_name_cn: "",
        choice_name_en: "",
        choice_name_th: "",
        choice_price: 0,
      });
    },

    removeChoice(index) {
      this.form.option_choice.splice(index, 1);
    },

    resetForm() {
      this.$emit("reset");
      this.$refs.form.resetValidation();
    },
    async submit() {
      if (this.$refs.form.validate()) {
        this.$emit("save");
      }
    },
  },
};
</script>

<style scoped>
.body__card--choice {
  border: 1px solid #e6e6e6;
  border-radius: 20px;
  padding: 20px;
}

.body__card {
  height: 70vh;
  overflow: scroll;
}

.body__card--choice .card__number {
  background-color: black;
  color: white;
  border-radius: 10px;
  padding: 5px 10px;
  font-size: 16px;
}

.body__title--choice {
  font-weight: bold;
  font-size: 20px;
}

.loading-section {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
}
.loading-item {
  animation: fade 2s infinite linear;
}
.loading-item-span {
  font-size: 28px;
}

@media screen and (max-width: 788px) {
  .body__card {
    height: 85vh;
  }
}
</style>